export default "__VITE_ASSET__BzeX4yx3__"